import PropTypes from 'prop-types';
import React from 'react';

import { FooterLinkType } from '@powdr/model';

import {
  StyledFooterNav, LinkList, LinkItem, FooterLink,
  OnetrustButton,
} from './styles';

// eslint-disable-next-line import/no-dynamic-require
const { gatsbyConfig } = require(`@powdr/${process.env.GATSBY_PROPERTY_NAME}`);

const openConsentPreferences = () => {
  if (typeof window === 'undefined') return;

  const removeExtraPreferenceCenters = () => {
    const preferenceCenters = document.querySelectorAll('#onetrust-pc-sdk');

    if (preferenceCenters.length > 1) {
      preferenceCenters.forEach((preferenceCenter, index) => {
        if (index > 0) {
          preferenceCenter.remove();
        }
      });
    }
  };

  const tryOpen = () => {
    if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
      removeExtraPreferenceCenters();
      window.OneTrust.ToggleInfoDisplay();
    } else {
      setTimeout(tryOpen, 100);
    }
  };

  tryOpen();
};

export const FooterNav = ({ footerLinks = [] }) => (
  <StyledFooterNav role="navigation" aria-label="Footer Site Navigation">
    <LinkList>
      {footerLinks.sort((a, b) => a.weight - b.weight).map((link) => (
        <LinkItem key={link.name}>
          <FooterLink
            className={link.classes}
            title={link.name}
            href={link.link}
            target={link?.linkTarget}
          >
            {link.name}
          </FooterLink>
        </LinkItem>
      ))}
      {(gatsbyConfig?.onetrustID) && (
        <LinkItem>
          <OnetrustButton type="button" id="ot-sdk-btn" className="onetrust-button" onClick={openConsentPreferences}>
            Your Privacy Rights
          </OnetrustButton>
        </LinkItem>
      )}
    </LinkList>
  </StyledFooterNav>
);

FooterNav.propTypes = {
  footerLinks: PropTypes.arrayOf(FooterLinkType),
};
